import React from 'react'
import Colors from 'utils/colors'

function NotFound() {
  return (
    <div style={styles.container}>
      <div style={styles.containerText}>
        <h2 style={styles.title}>404 - Página no encontrada</h2>
        <h1 style={styles.subtitle}>Lo sentimos, la página que buscas no existe.</h1>
      </div>
    </div>
  )
}

const styles = {
  container: {
    display: 'flex',
    justifyContent: 'center',
    height: '100vh',
    background: `linear-gradient(180deg, ${Colors.primary} 0%, ${Colors.secondary} 58.8%, ${Colors.black} 117.6%)`,
  },
  containerText: {
    marginLeft: '8%',
    width: '90%',
    marginTop: '5%'
  },
  title: {
    color: Colors.secondary,
    fontFamily: 'TTNormsBlack',
  },
  subtitle: {
    color: Colors.white,
    fontFamily: 'TTNormsRegular',
    display: 'flex',
    justifyContent: 'flex-start',
  },
}

export default NotFound
